import "./App.scss"
// import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from "react-router-dom";
import theme from './assets/themes/theme';
import PageRouters from "./routes/PageRouters";
import { ThemeProvider } from '@mui/material/styles';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const App = () => {
  return (
    <ThemeProvider theme={theme}>
      {/* <CssBaseline /> */}
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <PageRouters />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
